import { useState } from 'react';

export default function TestimonialSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      quote: "Nationwide Pallet Solution delivered 616 48×40 pallets in just three days. Exceptional service and quality!",
      name: "Michael Rodriguez",
      company: "Rodriguez Logistics",
      rating: 5
    },
    {
      id: 2,
      quote: "Best pallet supplier we've worked with. Their 4-way pallets are durable and the pricing is competitive. Highly recommend!",
      name: "Sarah Chen",
      company: "Chen Distribution Co.",
      rating: 5
    },
    {
      id: 3,
      quote: "Fast delivery, excellent customer service, and top-quality pallets. They've been our go-to supplier for over 2 years now.",
      name: "James Thompson",
      company: "Thompson Warehousing",
      rating: 5
    },
    {
      id: 4,
      quote: "The custom pallet solutions they provided perfectly fit our unique shipping requirements. Professional team and great communication.",
      name: "Emily Martinez",
      company: "Martinez Manufacturing",
      rating: 5
    },
    {
      id: 5,
      quote: "Reliable, affordable, and always on time. Their standard 48x40 pallets are exactly what we need for our operations.",
      name: "David Wilson",
      company: "Wilson Supply Chain",
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <p className="text-sm font-semibold text-gray-900 mb-12 flex items-center justify-center">
          <span className="w-2 h-2 bg-gray-900 rounded-full mr-2"></span>
          CLIENT TESTIMONIALS
        </p>

        <div className="relative max-w-4xl mx-auto">
          {/* Testimonial Content */}
          <div className="bg-white rounded-3xl shadow-xl p-12 min-h-[320px] flex flex-col justify-between">
            <div>
              <div className="flex items-center justify-center mb-6">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-orange-500 text-2xl mx-1"></i>
                ))}
              </div>

              <blockquote className="text-2xl md:text-3xl font-serif font-medium text-gray-900 leading-relaxed mb-8 text-center">
                <span className="text-4xl text-orange-500">"</span>
                {testimonials[currentIndex].quote}
                <span className="text-4xl text-orange-500">"</span>
              </blockquote>
            </div>

            <div className="text-center">
              <p className="text-xl font-bold text-gray-900">{testimonials[currentIndex].name}</p>
              <p className="text-sm text-gray-600 mt-1">{testimonials[currentIndex].company}</p>
              <p className="text-xs text-green-600 font-semibold mt-2 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill mr-1"></i>
                Verified Customer
              </p>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-16 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-orange-50 transition-colors cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-16 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-orange-50 transition-colors cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
          </button>

          {/* Dots Navigation */}
          <div className="flex items-center justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex
                    ? 'bg-orange-500 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="flex items-center justify-center mb-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-orange-500 text-xl"></i>
              ))}
            </div>
            <p className="text-sm text-gray-600">5.0 Rating</p>
          </div>
          <div className="text-center border-l border-r border-gray-300">
            <p className="text-3xl font-bold text-orange-500">150+</p>
            <p className="text-sm text-gray-600">Happy Clients</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-orange-500">5+</p>
            <p className="text-sm text-gray-600">Years Experience</p>
          </div>
        </div>
      </div>
    </section>
  );
}